import script from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__